import React from 'react';
import { connectToWebChat } from 'botframework-webchat';
import LiveChatCard1 from './live-chat-card/liveChatCard1';

const ConnectedAttachmentWithLiveChat1 = connectToWebChat(
  ({ postActivity }) => ({
    postActivity,
    onEndChat: () => {
      postActivity({
        type: 'closeLiveChat',
        name: 'closeLiveChat',
        value: null
      });
    }
  })
)(({ postActivity, onEndChat }) => (
  <LiveChatCard1 onEndChat={onEndChat} />
));

export default ConnectedAttachmentWithLiveChat1;
